/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

//@ts-ignore
import PocketBase, { User } from 'pocketbase'
import { TPagination } from '@/types/TPagination'

const project = window.location.hostname.split('.')[0]
const client: PocketBase = new PocketBase(process.env.VUE_APP_ENDPOINT || `https://${project}.be.invoicegun.strategio.dev`)

client.autoCancellation(false)

const hydratePagination = (resp: any): TPagination => {
    return {
        page: resp.page,
        perPage: resp.perPage,
        totalItems: resp.totalItems,
        totalPages: resp.totalPages
    }
}

const userProfile = () => {
    const user = client.authStore?.model as User | null
    return user?.profile
}

export const usePb = () => {
    return {
        client,
        hydratePagination,
        userProfile
    }
}